import React, { PropTypes } from "react";
import {Field, reduxForm} from "redux-form";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import axios from "axios";
import Constants from "../../classes/constants";
import Modal from "react-bootstrap/lib/Modal";
import Button from "react-bootstrap/lib/Button";
import {TextField} from "redux-form-material-ui";
import JobDetailsTable from "./JobDetailsTable";

class ReferralAdmin extends React.Component {
    constructor(props) {
        super(props);
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleChangeName = this.handleChangeName.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.deleteHandleShow = this.deleteHandleShow.bind(this);
        this.deleteHandleClose = this.deleteHandleClose.bind(this);
        this.deleteHandleSubmit = this.deleteHandleSubmit.bind(this);
        this.edit = this.edit.bind(this);

        this.state = {showPopUp: false, showDeletePopUp: false, add_type: '', name :'' , departments:[], jobTitles:[], jobs:[],
            referrals: {
                "0": {
                    departmentValue: "Select Department",
                    jobTitle: "Select Job Title"
                }
            }, file: null, src: "", selectedFileName:""
        };
    }

     edit(job) {
         var status = 0;
         var id = job.id;
         if(id != "" || id != 0){
                  let apiUrl = process.env.REQ_URL +'/referral/inactiveJobDetails';
                  axios.post(apiUrl, {data: {
                    status : status, id : id,
                  }}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
                      let data = new FormData();
                      data.append('department', job.deptId);
                      data.append('jobTitle', job.jobTitleId);
                      let xhr = new XMLHttpRequest();
                      xhr.open('POST', process.env.REQ_URL + '/referral/getReferralJobDetails', true);
                      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                      xhr.withCredentials = true;

                      // Set up a handler for when the request finishes.
                      xhr.onload = function () {
                        if (xhr.status === 200) {
                           let jsonData = JSON.parse(xhr.response);
                           let jobsData = jsonData.data
                           this.setState({jobs:jobsData});
                        } else {
                           alert('An error occurred!');
                        }
                      }.bind(this);
                      xhr.send(data);
                      alert('Deleted successfully');
                  }).catch((err)=> {
                      console.log("Delete not successful");
                  });
         }else{
            alert("No job details found");
         }
     }

    deleteHandleShow(){
       this.setState({ showDeletePopUp: true });
    }

    deleteHandleClose() {
       this.setState({ showDeletePopUp: false });
    }

    deleteHandleSubmit(event){
      event.preventDefault();

    }

    handleClose() {
      this.setState({ showPopUp: false });
    }

    handleShow() {
       this.setState({ showPopUp: true });
    }

    handleSubmit (event) {
      event.preventDefault();
      var type = this.state.add_type;
      if(type == 1){
        var name = this.state.name;
        if(name != ""){
          if(name.length<100){
            let apiUrl = process.env.REQ_URL +'/referral/addNewDepartment';
            axios.post(apiUrl, {data: {
              value: name,
            }}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
                alert('added successfully');
                axios.get(
                        process.env.REQ_URL +"/referral/getReferralDepartments",
                        {
                          withCredentials: true,
                          headers: { "X-Requested-With": "XMLHttpRequest" }
                        }
                      ).then(response => {
                        this.setState({ departments : response.data.data });
                      }).catch(error => {
                        console.log(
                          "error while calling api /referral/getReferralDepartments" + error
                        );
                      });
                this.setState({add_type: '', name: '', showPopUp: false});
            }).catch((err)=> {
                    console.log("Referral departments not added");
            });
          }else{
            alert("Maximum character limit(100) exceeded ");
          }
        }else{
          alert("Please Fill Department Name ");
        }
      }else if(type == 2){
        var name = this.state.name;
        if(name != ""){
          if(name.length<100){
            let apiUrl = process.env.REQ_URL +'/referral/addNewJobTitle';
            axios.post(apiUrl, {data: {
              value: name,
            }}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
              alert('added successfully');
              axios.get(
                      process.env.REQ_URL +"/referral/getReferralJobTitles",
                      {
                        withCredentials: true,
                        headers: { "X-Requested-With": "XMLHttpRequest" }
                      }
                    ).then(response => {
                      this.setState({ jobTitles : response.data.data });
                    }).catch(error => {
                      console.log(
                        "error while calling api /referral/getReferralJobTitles" + error
                      );
                    });
              this.setState({add_type: '', name: '', showPopUp: false});
            }).catch((err)=> {
              console.log("Job Title Not Added");
            });
          }else{
             alert("Maximum character limit(100) exceeded");
          }
        }else{
           alert("Please Fill Job Title");
        }
      }else{
        alert("Please select add type");
      }
    }

    handleChangeName(event) {
          this.setState({name: event.target.value});
    }

    navigate(url){
        let win = window.open();
        win.document.write('<iframe src="' + url  + '"frameborder="0" style="border:0; top:0px; left:0px; bottom:0px;' +
            ' right:0px; width:103%; height:100%;" allowfullscreen>view</iframe>');
    }



  componentDidMount() {
      let referralData = this.state.referrals[0];
      referralData.departmentValue = "";
      referralData.jobTitle = "";


      axios.get(
        process.env.REQ_URL +"/referral/getReferralDepartments",
        {
          withCredentials: true,
          headers: { "X-Requested-With": "XMLHttpRequest" }
        }
      ).then(response => {
        this.setState({ departments : response.data.data });
      }).catch(error => {
        console.log(
          "error while calling api /referral/getReferralDepartments" + error
        );
      });

      axios.get(
        process.env.REQ_URL +"/referral/getReferralJobTitles",
        {
          withCredentials: true,
          headers: { "X-Requested-With": "XMLHttpRequest" }
        }
      ).then(response => {
        this.setState({ jobTitles : response.data.data });
      }).catch(error => {
        console.log(
          "error while calling api /referral/getReferralJobTitles" + error
        );
      });
  }

  refresh() {
      let referralData = this.state.referrals[0];
      referralData.departmentValue = "";
      referralData.jobTitle = "";

      let request = {
        type: "1"
      };

      axios.get(
        process.env.REQ_URL +"/referral/getReferralDepartments",
        {
          withCredentials: true,
          headers: { "X-Requested-With": "XMLHttpRequest" }
        }
      ).then(response => {
        this.setState({ departments : response.data.data });
      }).catch(error => {
        console.log(
          "error while calling api /referral/getReferralDepartments" + error
        );
      });

      axios.get(
        process.env.REQ_URL +"/referral/getReferralJobTitles",
        {
          withCredentials: true,
          headers: { "X-Requested-With": "XMLHttpRequest" }
        }
      ).then(response => {
        this.setState({ jobTitles : response.data.data });
      }).catch(error => {
        console.log(
          "error while calling api /referral/getReferralJobTitles" + error
        );
      });
  }

  render() {
    return (
        <form action={'/referral/addUpdateJobDetails'} method="post" encType="multipart/form-data" id="jobDetailsUploadForm">
        <div className="responsive referral_table">
        <table className="table" cellpadding="0" cellspacing="0" border="0">
          {Object.keys(this.state.referrals).map(idx => {
            const item = this.state.referrals[idx];
            return (
              <tr id={idx} key={idx}>
                <td width="23%">
                  <div className="form-group">
                    <SelectField
                      labelStyle={{ color: "#1E88E5" }}
                      style={{ width: "80%", fontSize: "12px"}}
                      defaultValue="Select Department"
                      id = "department"
                      value={
                        this.state.referrals[idx] &&
                        this.state.referrals[idx].departmentValue
                      }
                      onChange={(option, data, department) => {
                        const departmentData = this.state.referrals[idx];
                        departmentData.departmentValue = department;
                        this.setState({
                            referrals : Object.assign( this.state.referrals, {[idx]: departmentData })
                        });
                      }}
                    >
                    <MenuItem value="" primaryText="Select a department" />
                    {this.state.departments.map((department) => {
                      return (
                        <MenuItem value={department.id} primaryText={department.departmentName}/>
                      );
                    })}
                    </SelectField>
                  </div>
                </td>

                <td width="23%">
                  <div className="form-group">
                    <SelectField
                      labelStyle={{ color: "#1E88E5" }}
                      style={{ width: "80%", fontSize: "12px"}}
                      defaultValue="Select a job title"
                      id = "jobTitle"
                      value={
                        this.state.referrals[idx] &&
                        this.state.referrals[idx].jobTitle
                      }
                      onChange={(option, data, jobTitle) => {
                        const referralJobTitleData = this.state.referrals[idx];
                        referralJobTitleData.jobTitle = jobTitle;
                        this.setState({
                          optional: false,
                          show: true,
                            referrals : Object.assign(this.state.referrals, {[idx]: referralJobTitleData})
                        });
                      }}
                    >
                    <MenuItem value="" primaryText="Select Job Title" />
                    {
                      this.state.jobTitles.map((jobTitle, index) => {
                        return (
                          <MenuItem value={jobTitle.id} primaryText={jobTitle.jobTitle}/>
                        );
                      })
                    }
                    </SelectField>
                  </div>
                </td>

                <td width="5%" style={{ textAlign: "center" }}>
                  <div className="uploadButton">
                          <button className="btn btn-primary upload_cta">Upload</button>
                          <input type="file" onChange={(event)=> {
                             var reader = new FileReader();
                             reader.onload = (e) => {
                                 this.setState({src: e.target.result});
                             };
                             reader.readAsDataURL(event.target.files[0]);
                             this.setState({file: event.target.files[0]});
                             document.getElementById('view').style.display = 'block';
                          }} name="jobDetailsFile" id = "jobDetailsFile" className="fileUpload" accept=".pdf"  />
                          <div id="file-upload-filename"></div>
                  </div>
                  <a onClick={()=>{this.navigate(this.state.src)}} style={{display: "none"}} id="view"> view </a>
                </td>
              </tr>
            );
          })}
        </table>

        <div className="cta_button">
          <button className="btn btn-secondary save_upload_cta"  type="button" onClick={(e)=> {
              e.preventDefault();
              let jobDetailsData = this.state.referrals[0];
              if(!jobDetailsData.departmentValue || !jobDetailsData.jobTitle ||!this.state.file) {
                  alert("Please fill all the fields.");
              } else {
                  let data = new FormData();
                  data.append('file', this.state.file, "FileName.pdf");
                  data.append('department', jobDetailsData.departmentValue);
                  data.append('jobTitle', jobDetailsData.jobTitle);
                  let xhr = new XMLHttpRequest();
                  xhr.open('POST', process.env.REQ_URL + '/referral/addUpdateJobDetails', true);
                  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                  xhr.withCredentials = true;

                  // Set up a handler for when the request finishes.
                  xhr.onload = function () {
                      if (xhr.status === 200) {
                          let jsonData = JSON.parse(xhr.response);
                          alert(jsonData.data);
                          jobDetailsData.departmentValue = "";
                          jobDetailsData.jobTitle = "";
                          this.setState({ file:null, src : ""});
                          $('#jobDetailsFile').val('');
                          $("#view").css("display", "none");
                      } else {
                          alert('An error occurred!');
                      }
                  }.bind(this);
                  xhr.send(data);
              }}}
          >Save</button>
          <Button className="btn btn-secondary add_new_dep_jt" variant="primary" onClick={this.handleShow}>Add New </Button>
          <Button className="btn btn-secondary delete_job_details" variant="primary" onClick={this.deleteHandleShow}>Delete</Button>


                    <Modal show={this.state.showPopUp} onHide={this.handleClose}>
                      <form name="add-department-job-title" onSubmit={this.handleSubmit}>
                        <Modal.Header closeButton>
                          <Modal.Title>ADD NEW</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <table style={{marginBottom: 0, width: '100%'}} className="table referral_table">
                            <tbody>
                              <tr>
                                <td style={{width: '200px'}}>
                                  <label>ADD TYPE :   </label>
                                </td>
                                <td style={{width: '200px'}}>
                                  <div className="form-group">
                                    <SelectField labelStyle={{ color: "#1E88E5" }}
                                    style={{ width: "80%", fontSize: "12px" }}
                                    defaultValue="Select add type"
                                    name="add_type" id="add_type" value = {this.state.add_type}
                                    onChange={(option, data, add_type) => {
                                      this.setState({
                                        optional: false,
                                        show: true,
                                        add_type : add_type
                                      });
                                    }}>
                                      <MenuItem value='' primaryText='Select add type'/>
                                      <MenuItem value='1' primaryText='Department'/>
                                      <MenuItem value='2' primaryText='Job Title'/>
                                    </SelectField>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td style={{width: '200px'}}>
                                  <label>NAME :   </label>
                                </td>
                                <td style={{width: '200px'}}>
                                  <div className="form-group">
                                    <Field name="add_name" id = "add_name" component={TextField} value = {this.state.name} onChange = {this.handleChangeName}/>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="secondary" onClick={this.handleClose}>
                            Close
                          </Button>
                          <input type="submit" value="Save Changes" color="primary" className="btn btn-primary" />
                        </Modal.Footer>
                      </form>
                   </Modal>

                   <Modal show={this.state.showDeletePopUp} onHide={this.deleteHandleClose}>
                                         <form name="delete_job_details">
                                           <Modal.Header closeButton>
                                             <Modal.Title>Delete Job Details</Modal.Title>
                                           </Modal.Header>
                                           <Modal.Body>
                                           <table className="table" cellpadding="0" cellspacing="0" border="0">
                                                     {Object.keys(this.state.referrals).map(idx => {
                                                       const item = this.state.referrals[idx];
                                                       return (
                                                         <tr id={idx} key={idx}>
                                                           <td width="40%">
                                                             <div className="form-group">
                                                               <SelectField
                                                                 labelStyle={{ color: "#1E88E5" }}
                                                                 style={{ width: "80%", fontSize: "12px" }}
                                                                 id = "departmentDelete"
                                                                 fullWidth={false}
                                                                 defaultValue="Select a department"
                                                                 value={
                                                                   this.state.referrals[idx] &&
                                                                   this.state.referrals[idx].departmentValue
                                                                 }
                                                                 onChange={(option, data, department) => {
                                                                   const departmentData = this.state.referrals[idx];
                                                                   departmentData.departmentValue = department;
                                                                   this.setState({
                                                                       referrals : Object.assign( this.state.referrals, {[idx]: departmentData })
                                                                   });
                                                                 }}
                                                               >
                                                               <MenuItem value="" primaryText="Select a department" />
                                                               {this.state.departments.map((department) => {
                                                                 return (
                                                                   <MenuItem value={department.id} primaryText={department.departmentName}/>
                                                                 );
                                                               })}
                                                               </SelectField>
                                                             </div>
                                                           </td>

                                                           <td width="50%">
                                                             <div className="form-group">
                                                               <SelectField
                                                                 labelStyle={{ color: "#1E88E5" }}
                                                                 style={{ width: "80%", fontSize: "12px"}}
                                                                 defaultValue="Select Job Title"
                                                                 fullWidth={false}
                                                                 id = "jobTitleDelete"
                                                                 value={
                                                                   this.state.referrals[idx] &&
                                                                   this.state.referrals[idx].jobTitle
                                                                 }
                                                                 onChange={(option, data, jobTitle) => {
                                                                   const referralJobTitleData = this.state.referrals[idx];
                                                                   referralJobTitleData.jobTitle = jobTitle;
                                                                   this.setState({
                                                                     optional: false,
                                                                     show: true,
                                                                       referrals : Object.assign(this.state.referrals, {[idx]: referralJobTitleData})
                                                                   });
                                                                 }}
                                                               >
                                                               <MenuItem value="" primaryText="Select Job Title" />
                                                               {
                                                                 this.state.jobTitles.map((jobTitle, index) => {
                                                                   return (
                                                                     <MenuItem value={jobTitle.id} primaryText={jobTitle.jobTitle}/>
                                                                   );
                                                                 })
                                                               }
                                                               </SelectField>
                                                             </div>
                                                           </td>
                                                           <td width="10%">
                                                           <button className="btn btn-default"  type="button" onClick={(e)=> {
                                                                         e.preventDefault();
                                                                         let jobDetailsData = this.state.referrals[0];
                                                                         if(!jobDetailsData.departmentValue || !jobDetailsData.jobTitle) {
                                                                             alert("Please fill all the fields.");
                                                                         } else {
                                                                             let data = new FormData();
                                                                             data.append('department', jobDetailsData.departmentValue);
                                                                             data.append('jobTitle', jobDetailsData.jobTitle);
                                                                             let xhr = new XMLHttpRequest();
                                                                             xhr.open('POST', process.env.REQ_URL + '/referral/getReferralJobDetails', true);
                                                                             xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                                                                             xhr.withCredentials = true;

                                                                             // Set up a handler for when the request finishes.
                                                                             xhr.onload = function () {
                                                                                 if (xhr.status === 200) {
                                                                                     let jsonData = JSON.parse(xhr.response);
                                                                                     let jobsData = jsonData.data
                                                                                     this.setState({jobs:jobsData});
                                                                                 } else {
                                                                                     alert('An error occurred!');
                                                                                 }
                                                                             }.bind(this);
                                                                             xhr.send(data);
                                                                         }}}
                                                                     >Find</button>
                                                           </td>
                                                         </tr>
                                                       );
                                                     })}
                                                   </table>
                                                   <JobDetailsTable jobs={this.state.jobs} edit={this.edit}/>
                                           </Modal.Body>
                                           <Modal.Footer>
                                             <Button variant="secondary" onClick={this.deleteHandleClose}>
                                               Close
                                             </Button>
                                           </Modal.Footer>
                                         </form>
                                      </Modal>
        </div>
      </div>
      </form>
    );
  }
}

ReferralAdmin.proptypes = {};

export default reduxForm({
  form: 'referralAdmin',
})(ReferralAdmin);



/** WEBPACK FOOTER **
 ** ./src/components/Referral/ReferralAdmin.js
 **/